import { takeEvery, takeLatest } from 'redux-saga/effects';
import { SETTINGS_MODULE } from '../../../configs/moduleNames';
import {
  DELETE_SETTINGS, LOAD_SETTINGS_BY_ID, LOAD_SETTINGS_ENUM_LIMITED, LOAD_SETTINGS_LIST,
} from '../actions';
import loadSettingsList from './loadSettingsList';
import loadSettingById from './loadSettingById';
import { CREATE, UPDATE } from '../../../configs/actionNames';
import createSetting from './createSetting';
import editSetting from './editSetting';
import deleteSetting from './deleteSetting';
import loadSettingEnumLimited from './loadSettingEnumLimited';

export default function* watchClient() {
  yield takeLatest(SETTINGS_MODULE + LOAD_SETTINGS_LIST, loadSettingsList);
  yield takeEvery(SETTINGS_MODULE + LOAD_SETTINGS_BY_ID, loadSettingById);
  yield takeEvery(SETTINGS_MODULE + DELETE_SETTINGS, deleteSetting);
  yield takeEvery(SETTINGS_MODULE + CREATE, createSetting);
  yield takeEvery(SETTINGS_MODULE + UPDATE, editSetting);
  yield takeEvery(SETTINGS_MODULE + LOAD_SETTINGS_ENUM_LIMITED, loadSettingEnumLimited);
}
